module.exports = __webpack_public_path__ + "202408221624/img/gold_3.a79edd6e.png";